import AppError from '@utils/AppError';

export function isAppErrAndStatus(
  error: unknown,
  statusCode: number,
): error is AppError {
  return error instanceof AppError && error.statusCode === statusCode;
}
